export const WORKSPACE_STORAGE_KEY = 'activeWorkspaceId';

/** A request pinned to one workspace (`expectedWorkspaceId`) found another one active when it was sent. */
export const WORKSPACE_CHANGED_MESSAGE = 'Your workspace changed in another tab. Reload this page and try again.';
